import profileImg from '../assets/img/team/basic-profile.png'
import 쭈롱프로필 from '../assets/img/team/쭈롱.png'

const teamMembers = [
    {
        name: "띵콜",
        role: "CEO",
        career: "",
        imgSrc: profileImg
    },
    {
        name: "쭈롱",
        role: "Lead Manager",
        career: "",
        imgSrc: 쭈롱프로필
    },
    {
        name: "상도동호랑이",
        role: "Lead Developer",
        career: "",
        imgSrc: profileImg
    },
    {
        name: "하나리",
        role: "Lead Marketer",
        career: "",
        imgSrc: profileImg
    },
]

function Team(){
    return (
            <section className="page-section bg-light" id="team">
                <div className="container">
                    <div className="text-center">
                        <h2 className="section-heading text-uppercase">Our Team</h2>
                        <h3 className="section-subheading text-muted">
                            캐리빌리의 가족을 소개합니다!
                        </h3>
                    </div>
                    <div className="row">
                        {teamMembers.map((member) => 
                            <div className="col-lg-4" key={member.name}>
                                <div className="team-member">
                                    <img
                                        className="mx-auto rounded-circle"
                                        src={member.imgSrc}
                                        alt={member.name}
                                    />
                                    <h4>{member.name}</h4>
                                    <p className="text-muted">{member.role}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section> 
    )
}

export default Team;